



































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IGame } from '~/store/games/types';

@Component
export default class GameRequiredItemButton extends Vue {
  @Prop(Object) readonly game!: IGame;
  @Prop({ type: String, default: 'medium-font' })
  readonly largeScreenFontSize!: IGame;
  @Prop(Boolean) readonly lowercaseText!: boolean;

  buttonText() {
    return this.$t('components.games.gameRequiredItemButton.buttonText');
  }

  goTo(url: string | undefined) {
    // UA tracking
    this.$ua.trackEarlyAccessRequiredEvent();

    window.location.href = url || window.location.href;
  }

  showTooltip() {
    return this.$route.matched.some(({ path }) => !!path?.match(/\/games\/.*/));
  }
}
